import { ERCText } from "components/text"
import React from "react"
import styles from './detailsbox.module.scss'

const DetailsBox = ({ img, numbers, text }) => {
    return (
        <div className={styles.body} >
            <div className={styles.imgdiv}>
                <img src={img} />
            </div>
            <div className={styles.stats}>
                <ERCText lHeight="32px" size='24px' weight='700' color='#00296B' >{numbers}</ERCText>
                <ERCText lHeight="24px" size="16px" weight="600">{text}</ERCText>
            </div>
        </div>
    )
}

export default DetailsBox